export const domainProject = 'project';
export const domainClient = 'client';
export const domainUserManagement = 'user-management';
export const domainControlPanel = 'control-panel';

export const permissionDomains = [domainProject, domainClient, domainUserManagement, domainControlPanel] as const;
export type PermissionDomains = typeof permissionDomains[number];
